"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverHelper = void 0;
var DriverHelper = /** @class */ (function () {
    function DriverHelper() {
    }
    DriverHelper.deleteDriver = function (interaction, driverId, vehicleIndex) {
        var vehicle = interaction.vehicles[vehicleIndex];
        var driverIds = vehicle.driverIds.filter(function (id) { return id !== driverId; });
        vehicle.driverIds = driverIds;
        vehicle.numberOfDrivers = driverIds.length;
        interaction.additionalDrivers = interaction.additionalDrivers
            .filter(function (driver) { return driver.personId !== driverId && driver.personId; });
        // if main driver is deleted and new main driver is not set, Polaris will fail to process such interaction
        if (vehicle.mainDriverId === driverId) {
            vehicle.mainDriverId = interaction.policyHolder.personId;
        }
        interaction.numberOfAdditionalDrivers = interaction.additionalDrivers.length;
    };
    return DriverHelper;
}());
exports.DriverHelper = DriverHelper;
//# sourceMappingURL=DriverHelper.js.map